declare module "axios" {
    export interface AxiosRequestConfig {
        ignoreGlobalError?: boolean,
        ignoreGlobalLoader?: boolean,
        ignoreUnauthorizedBehavior?: boolean
    }
}

import axios, { Axios } from 'axios'
import { AxiosInterceptorsResponse } from "@/api/AxiosInterceptorsResponse"
import { AxiosInterceptorsRequest } from "@/api/AxiosInterceptorsRequest"

const BaseAxios = axios.create()

let MyAxios: Axios = axios.create()

MyAxios = AxiosInterceptorsRequest(MyAxios);
MyAxios = AxiosInterceptorsResponse(MyAxios);

export default MyAxios

export {
    BaseAxios
}